import type { Moment } from "moment"
import { BaseModel } from "@/models/base.model"
import { ModelFactory } from "@/factories/model-factory"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model"
import type { IWorkspaceChecklistItem } from "@/workspace/interfaces/api/workspace-checklist-item.interface"

export class WorkspaceChecklistItem extends BaseModel implements IWorkspaceChecklistItem {
  public static className = "WorkspaceChecklistItem" // Used for socket communication.
  public static verboseName = "checklistitem"

  public static override managedResolveFields = ["assignee"]

  declare id: string
  /** The id of the note this item belongs to. */
  note: string
  body: string
  completedAt: Moment | null
  position: number
  assignee: KnownBusinessEntityContact | null
  remindAt: Moment | null
  reminderDateOnly: boolean

  constructor(item: IWorkspaceChecklistItem, managed = false) {
    super(item)

    this.note = item.note
    this.body = item.body
    this.completedAt = item.completedAt ?? null
    this.position = item.position
    this.assignee = item.assignee
      ? ModelFactory.childModel(KnownBusinessEntityContact, item.assignee, managed)
      : null
    this.remindAt = item.remindAt ?? null
    this.reminderDateOnly = Boolean(this.remindAt && item.reminderDateOnly)
  }

  /** The assignee as the checklist components read it. */
  public get assigneeId(): string | null {
    return this.assignee?.id ?? null
  }

  /** Completion is represented by the server timestamp; the client never manufactures it. */
  public get isCompleted(): boolean {
    return this.completedAt !== null
  }
}
